import { RootState } from "../Store";

export const SELECT_BANK_STATUSES = (state: RootState) =>
  state.authSlice.data.bank_statuses;

export const SELECT_USER_ROLE = (state: RootState) =>
  state.authSlice.data.user?.type;

export const SELECT_USER_CONTACTS = (state: RootState) =>
  state.authSlice.data.user?.contacts;

export const SELECT_USER_DATA = (state: RootState) => state.authSlice.data.user;

export const SELECT_TYPE_POSITION = (state: RootState) =>
  state.authSlice.typePosition;

export const SELECT_LOADING_PAGE = (state: RootState) =>
  state.authSlice.LoadingPage;
